export const layerStyles = {
  card: {
    bg: 'white',
    shadow: 'base',
    borderRadius: 'md',
  },
}
